import { BrandContentMap } from './types';

export const brandContentRO: BrandContentMap = {
  dacia: {
    title: "Mașini Dacia Second Hand Fiabile România",
    description: "Descoperă mașini Dacia rulate fiabile de la dealeri verificați. Logan, Duster și alte modele cu istoric complet auto și verificare profesională.",
    h1: "Mașini Dacia Rulate Fiabile - Dealeri Verificați România",
    intro: "Dacia rămâne cea mai populară marcă auto în România. Descoperă de ce mașinile Dacia second hand sunt alegerea inteligentă pentru siguranță și fiabilitate.",
    badge: "🏆 Cea mai populară marcă în România",
    models: [
      {
        name: "Dacia Logan",
        description: "Cea mai vândută mașină în România timp de 20 de ani consecutiv",
        features: ["Întreținere ieftină", "Piese disponibile peste tot", "Fiabilitate dovedită"]
      },
      {
        name: "Dacia Duster", 
        description: "SUV compact accesibil cu tracțiune integrală",
        features: ["SUV versatil", "Consum redus", "Spațiu generos"]
      },
      {
        name: "Dacia Sandero",
        description: "Mașină de oraș compactă și economică", 
        features: ["Perfect pentru oraș", "Economică", "Ușor de parcat"]
      }
    ],
    whyChoose: [
      "Piese de schimb accesibile în toată România",
      "Service-uri autorizate în fiecare județ", 
      "Istoric complet auto verificat de experți",
      "Dealeri verificați cu transparență totală"
    ],
    tips: [
      "Verifică istoricul de service complet",
      "Controlează starea tehnică la un service autorizat",
      "Cere toate documentele originale",
      "Testează toate sistemele electronice"
    ],
    stats: [
      { value: "20+", label: "Ani lider în România" },
      { value: "✓", label: "Istoric documentat" },
      { value: "500+", label: "Service-uri autorizate" },
      { value: "24/7", label: "Suport dealeri" }
    ],
    faqs: [
      {
        question: "Este Dacia o alegere bună pentru second hand?",
        answer: "Da! Dacia este ideal pentru second hand datorită fiabilității dovedite, întreținerii ieftine și disponibilității pieselor în toată România."
      },
      {
        question: "Care sunt cele mai populare modele Dacia?",
        answer: "Logan (lider 20 ani), Duster (SUV popular), Sandero (perfect pentru oraș) și Spring (electric accesibil)."
      },
      {
        question: "Cum verific istoricul unei Dacia second hand?",
        answer: "Dealerii noștri verificați oferă istoric complet auto, documente originale și raport tehnic profesional pentru fiecare Dacia."
      }
    ]
  },

  bmw: {
    title: "BMW de vânzare",
    description: "Anunțuri BMW de vânzare de la dealeri și persoane fizice, cu preț, an, kilometraj și fotografii. Contactează direct vânzătorul.",
    h1: "BMW de vânzare",
    intro: "Anunțuri BMW active de la dealeri și persoane fizice. Compară prețul, anul și kilometrajul, apoi contactează direct vânzătorul.",
    badge: "BMW",
    models: [
      {
        name: "BMW Seria 3",
        description: "Sedan premium cu echilibru perfect între performanță și confort",
        features: ["Tehnologie avansată", "Performanță sportivă", "Confort premium"]
      },
      {
        name: "BMW X3", 
        description: "SUV premium cu tracțiune integrală xDrive",
        features: ["SUV versatil", "xDrive pe multe versiuni", "Spațiu premium"]
      },
      {
        name: "BMW X5",
        description: "SUV de lux cu tehnologie de vârf", 
        features: ["Lux și confort", "Performanță superioară", "Tehnologie inovatoare"]
      }
    ],
    whyChoose: ["Verifică istoricul de service și documentele înainte de cumpărare", "Cere vânzătorului VIN-ul pentru o verificare independentă", "Fă o inspecție tehnică la un service ales de tine", "Insigna „Dealer verificat” se referă la firmă, nu la mașină"],
    tips: [
      "Verifică istoricul de service BMW",
      "Controlează sistemele electronice iDrive",
      "Testează xDrive pe traseu mixt",
      "Verifică actualizările software BMW"
    ],
    stats: [],
    faqs: [
      {
        question: "De ce să aleg BMW second hand?",
        answer: "BMW oferă tehnologie premium, performanță sportivă și ținută excelentă în timp, făcându-le ideale pentru second hand cu valoare păstrată."
      },
      {
        question: "Care sunt cele mai populare modele BMW?",
        answer: "Seria 3 (sedan premium), X3 (SUV compact), X5 (SUV luxury) și Seria 5 (sedan executiv) sunt printre cele mai cunoscute modele. Vezi lista de mai sus pentru modelele disponibile acum."
      },
      {
        question: "Cum verific tehnologia BMW la second hand?",
        answer: "Testează sistemele iDrive și asistența la condus în timpul probei, cere istoricul de service și, ideal, o verificare la un service independent. RO Auto Market nu inspectează vehiculele."
      }
    ]
  }
};
